import { useState } from 'react';
import { FiInfo } from 'react-icons/fi';

export default function FormulaModal({ title, formula, note }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="elevated inline-flex items-center justify-center rounded-xl border border-brand-border bg-brand-surface p-2 text-brand-muted hover:text-brand-text"
        aria-label="View formula details"
        title="View formula details"
      >
        <FiInfo size={18} />
      </button>

      {isOpen ? (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
          onClick={() => setIsOpen(false)}
          role="presentation"
        >
          <div
            className="elevated w-full max-w-lg rounded-2xl border border-brand-border bg-brand-surface p-5"
            onClick={(event) => event.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label={title}
          >
            <h2 className="text-lg font-bold">{title}</h2>
            <p className="mt-3 rounded-xl bg-brand-accentSoft px-3 py-2 text-sm font-medium text-brand-text">
              {formula}
            </p>
            {note ? <p className="mt-2 text-sm text-brand-muted">{note}</p> : null}
            <div className="mt-4 text-right">
              <button
                type="button"
                onClick={() => setIsOpen(false)}
                className="rounded-xl bg-brand-accent px-3 py-2 text-sm font-semibold text-white"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
